import React from 'react';
import footprintfull from '../../assets/imgs/footprint-full.svg';
import footprintreduce from '../../assets/imgs/footprint-reduce.svg';
import operatefull from '../../assets/imgs/operate-full.svg';
import operatereduce from '../../assets/imgs/operate-reduce.svg';
import { MapTypes } from '../shared/constants/MapTypes';
import Title from '../shared/Title';

const MapLocations = ({ mapType }) => {
    const mapTypeValidation = MapTypes.OPERATE;
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="flex flex-col items-center space-y-6">
        <div className="w-full">
          {mapType === mapTypeValidation ? (
            <>
              <Title text1="Locations" text2="Where We Operate" colorForText={2} />
              <div className="text-center">
                <p className="mb-5 text-light-grey-700 text-xl">
                  With a strong presence on the continent, we have four strategic locations across America, enabling us to provide optimal and localized service to our clients.
                </p>
              </div>
              <div className="relative w-full">
                <img 
                  src={operatefull} 
                  srcSet={`${operatereduce} 650w, ${operatefull} 900w`} 
                  alt="map" 
                  className="w-full h-auto object-contain" 
                />
              </div>
            </>
          ) : (
            <>
              <Title text1="Our" text2="Footprint" colorForText={2} />
              <div className="text-center">
                <p className="mb-5 text-light-grey-700 text-xl">
                  This map highlights the regions where our projects have reached, showcasing our presence and commitment to excellence.
                </p>
              </div>
              <div className="relative w-full">
                <img 
                  src={footprintfull} 
                  srcSet={`${footprintreduce} 650w, ${footprintfull} 900w`} 
                  alt="map" 
                  className="w-full h-auto object-contain" 
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MapLocations;
